import React from 'react'
import { useState, useEffect } from 'react'
import { Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { useAnalytics } from '@praxis/component-analytics'

import { SectionHeader } from '../../globalComponents/SectionHeader'
import { DownloadExplanationBox } from './DownloadExplanationBox'
import { TemplateUploadBox } from './TemplateUploadBox'
import { SpreadsheetHistoryTable } from './SpreadsheetHistoryTable'
import { VendorContext } from '../../globalState/Vendor/index'
import { trainingLinkUrl } from '../../globalConfig/constants'

export const SpreadsheetDashboard = () => {
  const { trackView } = useAnalytics()
  const [successfulUploadCount, setSuccessfulUploadCount] = useState(0)
  const [state] = React.useContext(VendorContext)

  useEffect(() => {
    trackView('/', 'Spreadsheet Dashboard Page')
  }, [trackView])

  const headerSubtext = (
    <>
      <span>
        {`Save time by bulk updating costs through an Excel Spreadsheet.  If
      you're not already familiar with our spreadsheet formatting you can `}
      </span>
      <a
        href={trainingLinkUrl}
        target="_blank"
        className="hesp-link"
        rel="noreferrer"
      >
        click here to learn more.
      </a>
    </>
  )

  const successfulUploadCallback = () => {
    setSuccessfulUploadCount(successfulUploadCount + 1)
  }

  return (
    <>
      <Layout.Body
        className="hesp-generic-layout"
        style={{
          overflowX: 'auto',
        }}
        data-testid="spreadsheetDashboardPage"
        includeRail
      >
        <Grid.Container style={{ minWidth: '720px' }}>
          <SectionHeader
            pageHeading="Spreadsheet Dashboard"
            subtext={headerSubtext}
          />
          <Grid.Item className="hesp-general-fullwidth">
            <p className="hc-fs-md hc-mb-normal">
              <strong>Update via Excel</strong>
            </p>
            <DownloadExplanationBox />
            <div className="hesp-spacer-normal" />
            <TemplateUploadBox
              successfulUploadCallback={successfulUploadCallback}
              vendorId={state?.selectedVendor}
            />
          </Grid.Item>
          <Grid.Item className="hesp-general-fullwidth hc-mt-normal">
            <p className="hc-fs-md hc-mb-normal">
              <strong>Spreadsheet History</strong>
            </p>
            <SpreadsheetHistoryTable
              successfulUploadCount={successfulUploadCount}
              vendorId={state?.selectedVendor}
            />
          </Grid.Item>
        </Grid.Container>
      </Layout.Body>
    </>
  )
}
